{
	"$schema": "https://schemas.wp.org/trunk/block.json",
	"apiVersion": 3,
	"name": "core/nextpage",
	"title": "Page Break",
	"category": "design",
	"description": "Separate your content into a multi-page experience.",
	"keywords": [ "next page", "pagination" ],
	"parent": [ "core/post-content" ],
	"textdomain": "default",
	"supports": {
		"customClassName": false,
		"className": false,
		"html": false,
		"interactivity": {
			"clientNavigation": true
		}
	},
	"editorStyle": "wp-block-nextpage-editor"
}
